// @flow
import { handleActions } from 'redux-actions';

import {
  GET_VACCINES,
  GET_VACCINES_SUCCESS,
  GET_VACCINES_FAILURE,
} from '../../actions/actionTypes';

const initialState = {
  vaccines: [],
};

export const vaccines = handleActions(
  {
    [GET_VACCINES]: state => (
      {
        ...state,
      }
    ),
    [GET_VACCINES_SUCCESS]: (state, {
      payload,
    }) => (
      {
        ...state,
        vaccines: [
          ...payload,
        ],
      }
    ),
    [GET_VACCINES_FAILURE]: state => (
      {
        ...state,
      }
    ),
  },
  initialState,
);
